export const JWT_SESSION_KEY = "jwt-token";

export enum STATUS_CODES {
  OK = 200,
  Created = 201,
  Accepted = 202,
  No_Content = 204,
  Bad_Request = 400,
  Unauthorized = 401,
  Forbidden = 403,
  Not_Found = 404,
  Method_Not_Allowed = 405,
  Not_Acceptable = 406,
  Not_Implemented = 501,
  Server_Error = 500,
}
